/* eslint-disable react/prop-types */ // TODO: add props

const ChevronSVG = ({ isOpen, className }) => {
  if (isOpen) {
    return (
      <svg
        width="12"
        height="7"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M11.28 6.53C11.14 6.67 10.94 6.75 10.75 6.75C10.56 6.75 10.37 6.68 10.22 6.53L6 2.31L1.78 6.53C1.64 6.67 1.44 6.75 1.25 6.75C1.06 6.75 0.86 6.68 0.72 6.53C0.58 6.38 0.5 6.19 0.5 6C0.5 5.81 0.58 5.61 0.72 5.47L5.47 0.72C5.62 0.570001 5.81 0.5 6 0.5C6.19 0.5 6.38 0.58 6.53 0.72L6.56 0.75L11.28 5.47C11.43 5.61 11.5 5.81 11.5 6C11.5 6.19 11.43 6.38 11.28 6.53Z"
          fill="#929394"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width="12"
        height="7"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M11.28 0.469999C11.14 0.329999 10.94 0.25 10.75 0.25C10.56 0.25 10.37 0.319999 10.22 0.469999L6 4.69L1.78 0.469999C1.64 0.329999 1.44 0.25 1.25 0.25C1.06 0.25 0.86 0.319999 0.72 0.469999C0.58 0.62 0.5 0.81 0.5 1C0.5 1.19 0.58 1.39 0.72 1.53L5.47 6.28C5.62 6.43 5.81 6.5 6 6.5C6.19 6.5 6.38 6.42 6.53 6.28L6.56 6.25L11.28 1.53C11.43 1.39 11.5 1.19 11.5 1C11.5 0.81 11.43 0.62 11.28 0.469999Z"
          fill="#9BABB3"
        />
      </svg>
    );
  }
};

export default ChevronSVG;
